// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchPage_form__oYq61","serviceSwitchWrapper":"SearchPage_serviceSwitchWrapper__GWIx0"};